var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.value
    ? _c(
        "button",
        {
          staticClass: "btn lg inverse success",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              _vm.value = 0
            }
          }
        },
        [
          _c(
            "i",
            { staticClass: "icon state-success" },
            [_c("Icon", { attrs: { name: _vm.icons[0] } })],
            1
          ),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm._f("trans")(_vm.words[0])))])
        ]
      )
    : _c(
        "button",
        {
          staticClass: "btn lg inverse error",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              _vm.value = 1
            }
          }
        },
        [
          _c(
            "i",
            { staticClass: "icon state-error" },
            [_c("Icon", { attrs: { name: _vm.icons[1] } })],
            1
          ),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm._f("trans")(_vm.words[1])))])
        ]
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-34b9c4c7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34b9c4c7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/helpers/mixins/form/Boolean.vue
// module id = null
// module chunks = 